import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { KeyValuePipe } from './../../pipes/keyvalue_pipe';
import { Subscription } from 'rxjs/Subscription';

import { Report, ReportService } from '../shared';
import { Meta } from '@angular/platform-browser';

import {
  CanComponentDeactivate,
  EntityService,
  ModalService,
  ToastService,
  MessageService
} from '../../core';
import { CONFIG } from "../../core/config";
import { environment } from "../../../environments/environment";

@Component({
  moduleId: module.id,
  selector: 'bp-report',
  templateUrl: './report.component.html',
})

export class ReportComponent implements OnDestroy, OnInit {
  @Input() report: Report;

  private dbResetSubscription: Subscription;
  private id: any;
  private srFileDownload: string;
  constructor(
    private metaService: Meta,
    private entityService: EntityService,
    private modalService: ModalService,
    private route: ActivatedRoute,
    private router: Router,
    private reportService: ReportService,
    private toastService: ToastService) { }



  ngOnInit() {
    this.route
      .params
      .map(params => params['id'])
      .do(id => this.id = +id)
      .subscribe(id => this.getReport());
    //TODO:SREDI LINK
    let baseUrl = this.metaService.getTag("name='apiurl'").content;
    this.srFileDownload =  baseUrl + CONFIG.baseUrls.reports + "/ReportFile/";
    //this.srFileDownload = environment.serverUrl + '/' + CONFIG.baseUrls.reports + "/ReportFile/";
  }

  ngOnDestroy() {
    // this.dbResetSubscription.unsubscribe();
  }


  private getReport() {
    if (this.id === 0) { return; }; //TODO: nece da radi zato sto ima id ===0

    this.reportService.getReport(this.id)
      .subscribe(report => {
        console.log('IZvestaj 1 ', report);
        this.report = report;
      });
  }

  private gotoReports() {
    this.router.navigate(['/reports']);
  }

  private handleServiceError(op: string, err: any) {
    console.error(`${op} error: ${err.message || err}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/reports/report/report.component.ts